import getCdnUrl from '../../../helpers/get-cdn-url';

const Background = getCdnUrl('/landings/background-desktop@2x-80q.webp');

export default Background;
